import { useAuthentication, useAuthorization } from '@autone/auth';
import { type PropsWithChildren } from 'react';

import LoadingScreen from '../components/loading-screen';
import NoAccess from '../views/permission/NoAccess';

export const AuthGuard = ({ children }: PropsWithChildren) => {
  const { isLoading, isAuthenticated, requiresAuthentication } =
    useAuthentication();
  const { hasCurrentModuleAccess } = useAuthorization();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated && requiresAuthentication) {
    // eslint-disable-next-line no-console
    console.log('AuthGuard: User is not authenticated');
    return <LoadingScreen />;
  }

  if (!hasCurrentModuleAccess && requiresAuthentication) {
    // eslint-disable-next-line no-console
    console.log('AuthGuard: User is not authorized');
    return <NoAccess />;
  }

  return children;
};
